import { render, staticRenderFns } from "./erikoisala.vue?vue&type=template&id=96450a42&scoped=true&"
import script from "./erikoisala.vue?vue&type=script&lang=ts&"
export * from "./erikoisala.vue?vue&type=script&lang=ts&"
import style0 from "./erikoisala.vue?vue&type=style&index=0&id=96450a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96450a42",
  null
  
)

export default component.exports